import { createFileRoute } from "@tanstack/react-router";

import { loginSearchParamsSchema } from "../../pages/login-page/types";

export const Route = createFileRoute("/login")({
  validateSearch: loginSearchParamsSchema,
});
